module.exports = __webpack_public_path__ + "static/media/ground-large.e86d117c.webp";